import React from "react";
import ReactApexChart from "react-apexcharts";

export default function SpineAndColumnChart({
    dataColors,
    series,
    xaxisConfig,
}) {
    const options = {
        chart: {
            height: "300",
            stacked: false,
            type: "line",
        },
        dataLabels: {
            enabled: false,
        },
        stroke: {
            curve: "smooth",
            width: 3,
        },
        markers: {
          size: 0
        },
        plotOptions: {
            bar: {
                columnWidth: "50%",
            },
        },
        colors: ["#00E396", "#FF4560", "#007bff"],
        xaxis: xaxisConfig,
        labels: xaxisConfig.categories || [],
        grid: {
            borderColor: "#f1f1f1",
        },
        legend: {
            show: true,
            position: "bottom"
        },
    };

    return (
        <ReactApexChart
            options={options}
            series={series || []}
            type="line"
            height={300}
        />
    );
}
